module.exports = __webpack_public_path__ + "static/logo-tutor-59faef78b6f3c718ddbb4c98889e2370.svg";